import { useEffect, useState } from 'react';

type Options = {
  offsetY?: number;
};

function useScrollBottom({ offsetY = 0 }: Options = {}) {
  const [isBottomDetect, setBottomDetect] = useState<boolean>(false);

  function scroll() {
    if (
      document.documentElement.scrollHeight > 0 &&
      document.documentElement.clientHeight > 0 &&
      document.documentElement.scrollHeight !==
        document.documentElement.clientHeight
    ) {
      const contentHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const supportPageOffset = window.pageXOffset !== undefined;
      const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';
      const y = supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
      const detect = Math.ceil(y + offsetY) >= contentHeight;

      setBottomDetect(() => detect);
    }
  }

  const init = () => {
    window.addEventListener('scroll', scroll);
    scroll();
    return () => {
      window.removeEventListener('scroll', scroll);
    };
  };
  useEffect(init, []);

  return isBottomDetect;
}

export default useScrollBottom;
